/*
 * Copyright (c) 2021 biocrates life sciences ag, All rights reserved.
 */

export type EnvProperty =
    | "APPLICATION_NAME"
    | "USER_ACCOUNT_URL"
    | "TERMS_AND_CONDITIONS_URL"
    | "PRIVACY_POLICY_URL"
    | "EULA_URL"
    | "THIRD_PARTY_LICENSES_URL"
    | "USER_MANUAL_URL"
    | "EULA_LABEL"
    | "REPORT_SPACE_URL"
    | "YOUTRACK_PROJECT_SHORT_NAME"
    | "INVALID_LICENSE_URL"
    | "SHOP_URL"

interface Env {
    APPLICATION_NAME: string
    USER_ACCOUNT_URL: string
    TERMS_AND_CONDITIONS_URL: string
    PRIVACY_POLICY_URL: string
    EULA_URL: string
    THIRD_PARTY_LICENSES_URL: string
    USER_MANUAL_URL: string
    EULA_LABEL: string
    REPORT_SPACE_URL: string
    YOUTRACK_PROJECT_SHORT_NAME: string
    INVALID_LICENSE_URL: string
    SHOP_URL: string
}

const env = (property: EnvProperty): string => {
    // eslint-disable-next-line
    const __ENV: Env = (window as any).__ENV as Env
    return __ENV[property]
}

export default env
